export const enum ProductDetailsEnum {
    /**
     * Normalized form of the "Days to Ship" attribute value returned by the API
     * (e.g. "Contact Us"), after applying toLowerCase().replace(/\s/g, "").
     * Compare against the value produced by that same normalization, not the raw API string.
     */
    ContactUs = "contactus",
}
